import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './initialState';

const appConfigFeatureFlagsSlice = createSlice({
  name: 'appConfigFeatureFlags',
  initialState: initialState.appConfigFeatureFlags,
  reducers: {
    fetchFeatureFlagsRequest: state => {
      state.isError = false;
      state.isLoading = true;
    },
    fetchFeatureFlagsResponse: (state, action: PayloadAction<AdvisorAppConfigValues>) => {
      state.flags = action.payload;
      state.isError = false;
      state.isLoading = false;
      state.isLoaded = true;
    },
    fetchFeatureFlagsFailure: state => {
      state.isError = true;
      state.isLoading = false;
      state.isLoaded = true;
    },
  },
});

export const {
  fetchFeatureFlagsRequest,
  fetchFeatureFlagsResponse,
  fetchFeatureFlagsFailure,
} = appConfigFeatureFlagsSlice.actions;

export const appConfigFeatureFlagsReducer = appConfigFeatureFlagsSlice.reducer;
